/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation SenderRoutePlanDeleteManyMutation($routePlanIds: [ID!] !) {
    SenderRoutePlanDeleteMany(routePlanIds: $routePlanIds){
      message
      status
    }
  }
`
